export default __webpack_public_path__ + "static/media/blog-post-layout-04-img-09.e08b51f1.jpg";